export enum BillableItemType {
  FLAT_FEE = 'Flat Fee',
  TIME_ENTRY = 'Time Entry',
  EXPENSE = 'Expense'
}
